import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Copyright 1999-2020. Plesk International GmbH. All rights reserved.

/* eslint-disable react/no-deprecated */
import React, { cloneElement, Component, Fragment, createRef } from 'react';
import { findDOMNode } from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import PopperJs from 'popper.js';
import Layer from '../Layer';
/**
 * `Popper` component.
 */

var Popper =
/*#__PURE__*/
function (_Component) {
  _inherits(Popper, _Component);

  function Popper() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Popper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Popper)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      popperStyle: null,
      arrowStyle: null,
      actualPlacement: _this.props.placement
    });

    _defineProperty(_assertThisInitialized(_this), "popper", null);

    _defineProperty(_assertThisInitialized(_this), "contentRef", createRef());

    _defineProperty(_assertThisInitialized(_this), "extractStyles", function (state) {
      if (!state) {
        return;
      }

      var onUpdate = _this.props.onUpdate;
      var data = {
        popperStyle: _objectSpread({
          position: state.offsets.popper.position
        }, state.hide ? {
          visibility: 'hidden',
          pointerEvents: 'none'
        } : undefined, {}, state.styles),
        actualPlacement: state.placement,
        arrowStyle: state.arrowStyles
      };

      _this.setState(data);

      if (onUpdate) {
        onUpdate(data);
      }
    });

    return _this;
  }

  _createClass(Popper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updatePopper(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      var _this$props = this.props,
          show = _this$props.show,
          boundariesElement = _this$props.boundariesElement,
          placement = _this$props.placement,
          offset = _this$props.offset,
          behavior = _this$props.behavior,
          arrow = _this$props.arrow;

      if (prevProps.show !== show || prevProps.boundariesElement !== boundariesElement || prevProps.placement !== placement || prevProps.offset !== offset || prevProps.behavior !== behavior || prevProps.arrow !== arrow) {
        setTimeout(function () {
          _this2.updatePopper(_this2.props);
        }, 0);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.popper) {
        this.popper.destroy();
      }
    }
  }, {
    key: "updatePopper",
    value: function updatePopper(_ref) {
      var show = _ref.show,
          boundariesElement = _ref.boundariesElement,
          placement = _ref.placement,
          offset = _ref.offset,
          behavior = _ref.behavior,
          arrow = _ref.arrow,
          targetRef = _ref.targetRef;

      if (this.popper) {
        this.popper.destroy();
      }

      if (!this.contentRef.current || !show) {
        return;
      }

      var popperOpts = {
        placement: placement,
        modifiers: {
          applyStyle: {
            enabled: false
          },
          applyReactStyle: {
            enabled: true,
            fn: this.extractStyles,
            order: 900
          },
          preventOverflow: {
            enabled: true,
            boundariesElement: boundariesElement
          },
          hide: {
            enabled: true
          },
          offset: {
            enabled: true,
            offset: offset
          },
          flip: {
            enabled: true,
            padding: 0,
            behavior: behavior
          },
          arrow: arrow && {
            enabled: true,
            element: this.arrowRef
          }
        }
      };
      var reference;

      if (targetRef && targetRef.current) {
        reference = targetRef.current;
      } else {
        reference = findDOMNode(this);
      }

      this.popper = new PopperJs(reference, this.contentRef.current, popperOpts);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          baseClassName = _this$props2.baseClassName,
          className = _this$props2.className,
          children = _this$props2.children,
          target = _this$props2.target,
          targetRef = _this$props2.targetRef,
          arrow = _this$props2.arrow,
          placement = _this$props2.placement,
          behavior = _this$props2.behavior,
          offset = _this$props2.offset,
          onUpdate = _this$props2.onUpdate,
          zIndex = _this$props2.zIndex,
          show = _this$props2.show,
          boundariesElement = _this$props2.boundariesElement,
          style = _this$props2.style,
          props = _objectWithoutProperties(_this$props2, ["baseClassName", "className", "children", "target", "targetRef", "arrow", "placement", "behavior", "offset", "onUpdate", "zIndex", "show", "boundariesElement", "style"]);

      var popperStyle = this.state.popperStyle;
      var _this$state = this.state,
          arrowStyle = _this$state.arrowStyle,
          actualPlacement = _this$state.actualPlacement;
      var arrowElement = arrow && cloneElement(arrow, {
        ref: function ref(_ref2) {
          return _this3.arrowRef = _ref2;
        },
        style: arrowStyle
      });

      if (!popperStyle) {
        popperStyle = {
          visibility: 'hidden',
          top: 0,
          left: 0
        };
      }

      return React.createElement(Fragment, null, target, show ? React.createElement(Layer, {
        level: zIndex
      }, React.createElement("div", _extends({
        ref: this.contentRef,
        className: classNames(baseClassName, className, "".concat(baseClassName, "--placement-").concat(actualPlacement)),
        style: _objectSpread({}, style, {
          position: 'absolute'
        }, popperStyle)
      }, props), children, arrowElement)) : null);
    }
  }]);

  return Popper;
}(Component);

Popper.propTypes = {
  /**
   * Whether show popper content.
   */
  show: PropTypes.bool,

  /**
   * Content of the `Popper`.
   */
  children: PropTypes.node,

  /**
   * Target for popper.
   */
  target: PropTypes.any.isRequired,

  /**
   * A React reference to the DOM element that needs for calculating the position of the popup.
   */
  targetRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(HTMLElement)
  })]),

  /**
   * Arrow element of popper
   */
  arrow: PropTypes.element,

  /**
   * Placement for popper.
   */
  placement: PropTypes.oneOf(['auto', 'auto-start', 'auto-end', 'auto-top', 'auto-right', 'auto-bottom', 'auto-left', 'top', 'top-start', 'top-end', 'right', 'right-start', 'right-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end']),

  /**
   * The behavior used to change the popper's placement.
   */
  behavior: PropTypes.oneOfType([PropTypes.oneOf(['flip', 'clockwise', 'counterclockwise']), PropTypes.arrayOf(PropTypes.string)]),

  /**
   * Shift your popper on both axis.
   */
  offset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Update callback function
   */
  onUpdate: PropTypes.func,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  baseClassName: PropTypes.string,

  /**
   * zIndex value.
   */
  zIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Boundaries element for preventOverflow property.
   */
  boundariesElement: PropTypes.oneOfType([PropTypes.oneOf(['scrollParent', 'window', 'viewport']), PropTypes.instanceOf(HTMLElement)]),

  /**
   * @ignore
   */
  style: PropTypes.object
};
Popper.defaultProps = {
  show: true,
  children: null,
  arrow: null,
  placement: 'bottom-start',
  behavior: 'flip',
  offset: '0, 0',
  onUpdate: null,
  className: null,
  baseClassName: "".concat(CLS_PREFIX, "popper"),
  zIndex: null,
  boundariesElement: 'window',
  style: undefined,
  targetRef: undefined
};
export default Popper;